import { render, staticRenderFns } from "./boletim.vue?vue&type=template&id=3cbcc9ff&"
import script from "./boletim.vue?vue&type=script&lang=js&"
export * from "./boletim.vue?vue&type=script&lang=js&"
import style0 from "./boletim.vue?vue&type=style&index=0&id=3cbcc9ff&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports